export declare namespace AppSeparatorTokenSections {
	interface Platinum {
		background: string;
	}

	interface Neutral {
		background: string;
	}
}

export type AppSeparatorTokens = {
	background: string;
	platinum: AppSeparatorTokenSections.Platinum;
	neutral: AppSeparatorTokenSections.Neutral;
};

export const platinum: AppSeparatorTokenSections.Platinum = { background: '{platinum.normal}' };

export const neutral: AppSeparatorTokenSections.Neutral = { background: '{neutral.300}' };

/** `app-separator` line colours (`css/appSeparator`). */
export default {
	background: '{surface.100}',
	platinum,
	neutral,
} satisfies AppSeparatorTokens;
